import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@app/services/error.service';
import { Role, rolesMapping } from '@data/models/role.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const ROLE_SERVICE_API_ROOT = '/auth/v1/roles';

@Injectable()
export class RoleService {

    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient
    ) {
        this.errors = this.errorService.roleServiceErrors;
    }

    /**
     * Get list of all roles
     * @returns {Observable<Role[]}
     */
    public getRoles(isInternal?: boolean): Observable<Role[]> {
        let options = {};
        if (isInternal !== undefined) {
            const params = {
                filter: `app:(${isInternal ? environment.synappsAppId : environment.plumeAppId}|${environment.lockboxId})`
            };
            options = { params };
        }

        return this.http.get<{ roles: Role[] }>(ROLE_SERVICE_API_ROOT, options).pipe(
            map((result) => result.roles),
            map((roles) => roles.map((role) => {
                const roleDescription = rolesMapping.find(({ id }) => id === role.id);
                if (roleDescription) {
                    role.description = roleDescription.description;
                }
                return role;
            })
            ),
            catchError(this.errorService.errorHandler<Role[]>(this.errors, 'Récupération des rôles', []))
        );
    }

}

